import React from 'react';
import { useIntl } from 'react-intl';
import { HelpCircle } from 'lucide-react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import Tooltip from '@/components/ui-bridge/core/Tooltip';

const RequestFormWidgetStringMultiline = ({
  id,
  disabled,
  label,
  onChange,
  options,
  rawErrors,
  required,
  value,
  placeholder,
}) => {
  const intl = useIntl();
  const error = !!(rawErrors && rawErrors?.length > 0);

  return (
    <div className="w-full">
      <label 
        className="inline-block text-[12px] font-bold text-[#212529] font-['Open_Sans'] mt-[0.3vh] mb-1 tracking-tight" 
        htmlFor={id}
      >
        {intl.formatMessage({ id: label })}
        {required && <span className="text-red-500 ml-0.5">*</span>}
      </label>

      <div className="relative flex items-center">
        <textarea
          disabled={disabled}
          id={id}
          data-cy={id}
          rows={options?.rows || 3}
          value={value || ''}
          onChange={event => onChange(event.target.value)}
          placeholder={placeholder ? intl.formatMessage({ id: placeholder }) : ''}
          style={{ fontWeight: 'normal', color: disabled ? 'rgba(0, 0, 0, 0.38)' : '#212529' }}
          className={classNames(
            "w-full rounded-[4px] px-[12px] py-[8px] text-[14px] !font-normal font-['Open_Sans'] transition-all focus:outline-none resize-y",
            {
              "bg-white": !disabled,
              "!text-[#212529]": !disabled,
              "border-[1px] border-solid border-[#dc3545] focus:border-[#dc3545]": error,
              "border-[1px] border-solid border-[#ced4da] focus:border-[#80bdff]": !error,
              "bg-[#efefef] cursor-not-allowed text-[rgba(0,0,0,0.38)]": disabled
            }
          )}
        />

        {options?.tooltip && (
          <div className="absolute right-3 top-2 flex items-center z-10">
            <Tooltip 
              title={intl.formatMessage({ id: options.tooltip?.message })}
              placement="top"
            >
              <HelpCircle size={18} className="text-[#5882c1] cursor-help transition-colors hover:text-[#46699d]" />
            </Tooltip>
          </div>
        )}
      </div>

      {error && (
        <p className="order-form-field-error">
          {rawErrors[0]}
        </p>
      )}
    </div>
  );
};

RequestFormWidgetStringMultiline.propTypes = {
  id: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  label: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  rawErrors: PropTypes.array,
  required: PropTypes.bool,
  value: PropTypes.any,
  options: PropTypes.object,
  placeholder: PropTypes.string,
};

RequestFormWidgetStringMultiline.defaultProps = {
  disabled: false,
  required: false,
  rawErrors: [],
  value: undefined,
  options: {},
  placeholder: null,
};

export default RequestFormWidgetStringMultiline;
